import React from "react";
import { Modal } from "antd";
import { t } from "i18next";
import {
  InputText,
  NumberInput,
  SelectInput,
  Form,
  Button,
  Spin
} from "common/elements";
import { getOne, insertNewRecord, updateRecordById } from "services/leave_type";

export default class FormInsertOrUpdate extends React.PureComponent {
  state = {
    isModalVisible: false,
    id: null,
    loading: false,
    disabled: false,
    loadingFormData: false,
  };

  showModal = (id) => {
    if (id) {
      this.setState({ loadingFormData: true, isModalVisible: true });
      getOne(id)
        .then((response) => {
          if (response) {
            const formData = response.data;
            this.props.form.setFieldsValue({
              name: formData.name,
              nameKH: formData.nameKH,
              numberAllow: formData.numberAllow,
              allowRemainMaximum: formData.allowRemainMaximum,
              type: formData.type,
              order: formData.order,
              isPayable: formData.isPayable
            });
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            this.props.navigate("/signin");
          }
        })
        .finally(() => {
          this.setState({
            isModalVisible: true,
            id,
            loadingFormData: false,
          });
        });
    } else {
      this.setState({
        isModalVisible: true,
        id: null,
      });
    }
  };

  handleCancel = () => {
    this.props.form.resetFields();
    this.setState({
      isModalVisible: false,
      disabled: false,
      loading: false,
    });
  };

  onFinish = (values) => {
    this.setState({ loading: true, disabled: true });
    if (this.state.id) {
      updateRecordById(this.state.id, values)
        .then(() => {
          this.setState({ isModalVisible: false });
          this.props.form.resetFields();
          this.props.onSuccess();
        })

        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    } else {
      insertNewRecord(values)
        .then(() => {
          this.setState({ isModalVisible: false });
          this.props.form.resetFields();
          this.props.onSuccess();
        })

        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  }

  render() {

    const { 
      isModalVisible, 
      loading, 
      loadingFormData, 
      id, 
      disabled 
    } = this.state;
    return isModalVisible ? (
      <Modal
        title={id ? t("text_edit_leave_type") : t("text_new_leave_type")}
        visible={isModalVisible}
        onCancel={this.handleCancel}
      >
        <Spin spinning={loadingFormData}>
          <Form
            form={this.props.form}
            onFinish={this.onFinish}
            layout="vertical"
            onFinishFailed={this.onFinishFailed}
            key={id}
            id="formLeaveType"
          >
            <InputText
              name="name"
              label={t("text_name")}
              placeholder={t("text_leave_type_name")}
              requiredMessage={t("text_please_input_leave_name")}
            />

            <InputText
              name="nameKH"
              label={t("text_name_Kh")}
              placeholder={t("text_leave_type_name")}
              requiredMessage={t("text_please_input_leave_name")}
            />

            <Form.Item
              name="numberAllow"
              label={t("text_entilement")}
              rules={[
                {
                  required: true,
                  message: t("text_please_input_number_allow"),
                },
              ]}
            >
              <NumberInput
                name="numberAllow"
                placeholder={t("text_how_many_day_allowe_for_employee_leave")}
                style={{ width: "100%", margin: 0 }}
                defaultValue={Number}
              />
            </Form.Item>

            <NumberInput
              name="allowRemainMaximum"
              label={t("text_carry_forward")}
              placeholder={t("text_do_you_allow_remain_leave_for_reuse_next")}
              defaultValue={Number}
            />

            <SelectInput
              name="type"
              placeholder={t("text_select_type")}
              label={t("text_type")}
              errorMessage={t("text_please_select_type")}
              valueKey="id"
              required={true}
              showArrow={true}
              dataSource={[
                { id: 1, name: t("text_annual_leave") },
                { id: 2, name: t("text_sick_leave") },
                { id: 3, name: t("text_maternity_leave") },
                { id: 4, name: t("text_paternity_leave") },
                { id: 5, name: t("text_special") },
                { id: 6, name: t("text_unpaid") },
                { id: 7, name: t("text_compensation_leave") },
                { id: 8, name: t("text_job_seeking_leave") }
              ]}
            />
            <NumberInput
              name="order"
              label={t("text_order")}
              placeholder={t("text_order")}
            />

            <div className="ant-modal-footer2">
              <Button
                className="btn-cancel"
                onClick={this.handleCancel}
                disabled={disabled}
              >
                {t("text_cancel")}
              </Button>
              <Button
                className="btn-save"
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                {t("text_save")}
              </Button>
            </div>
          </Form>
        </Spin>
      </Modal>
    ) : (
      <div />
    );
  }
}
